import { BaseApi } from './base.api.js';

export class RiskConsequenceApi extends BaseApi {
    constructor(client) {
        super(client, '/risk-consequence');
    }
}
